/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState } from 'react';
import { v4 as uuid } from "uuid";
import { XIcon } from "@heroicons/react/solid";
import {AddCircle as AddIcon} from '@mui/icons-material';

export default function Units({close, type, value}){

  const unitsArr = value?.units;

  const defaultValueArr = [];
  if (unitsArr && unitsArr.length){
    unitsArr.forEach((a, i)=>defaultValueArr.push({
      key:i,
      conversion: (a.unit_denominator && a.unit_numerator) ? (a.unit_numerator ==='1'? a.unit_denominator : `${a.unit_denominator}/${a.unit_numerator}`) : i===0 ? '1':'',
      unit_is_primary: a.unit_is_primary || i===0 ? 'Y':'N',
      unit_name: a.unit_name || '',
      unit_remarks: a.unit_remarks || '',
      unit_status:a.unit_status ? (a.unit_status === '1' ? true : false) : true,
      unit_uuid: a.unit_uuid || '',
    }))
  }
  const DEFAULT_VALUES = defaultValueArr.length ? defaultValueArr : [
    { 
      key: 0,
      conversion: '1',
      unit_is_primary:'Y',
      unit_name:'',
      unit_remarks:'',
      unit_status: true,
      unit_uuid:'',
    }
  ];
  const [tableData, setTableData] = useState(DEFAULT_VALUES);
  const [editValues, setEditValues] = useState(false);
  
  useEffect(() => {
    console.log(tableData)
  }, [tableData]);

  useEffect(() => {
    document.addEventListener("keydown", function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        addNewRow();
        return false;
      }
    });
  },[]);

  const addNewRow = async () => {
    const arr = tableData;
    arr.push({ 
      key: tableData.length,
      conversion: '',
      unit_is_primary:'N',
      unit_name:'',
      unit_remarks:'',
      unit_status:true,
      unit_uuid:'',
    });
    setTableData([...arr]);
  }

  const CreateUnitInDB = async () => {
    const arr1 = [];
    tableData.forEach((a)=>{
      if(a.conversion && a.unit_name){
        const denominator = a.conversion?.indexOf('/') >=0 ? a.conversion?.substr(0, a.conversion?.indexOf('/')) : a.conversion;
        const numerator = a.conversion?.indexOf('/') >=0 ? a.conversion?.substr(a.conversion?.indexOf('/')+1, a.conversion?.length) : '1';
        arr1.push({
          unit_denominator: denominator,
          unit_is_primary: a.unit_is_primary,
          unit_name: a.unit_name,
          unit_numerator: numerator,
          unit_remarks: a.unit_remarks,
          unit_status: a.unit_status? '1': '0',
          unit_uuid: a.unit_uuid || uuid(),
        })
      }
    })
    
    if(arr1.length){
      const json = {
        item_uuid: value.item_uuid,
        units: arr1
      }
      const url = `https://api.myfooddo.com/item/UpdateItemUnits`;
      // const url = `http://localhost:5000/item/UpdateItemUnits`;
      console.log(url, json);
      await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
      .then(res => res.json())
      .then(data => {
        console.log("UpdateItemUnits...", data);
      })
      .catch(err => console.warn("post request failed", err));
    }
  }

  const handleSave = async (e)=>{
    e.preventDefault();
    CreateUnitInDB();
    close()
  }
    
  return (
    <div className="newCategory" draggable={false}>
      <form className="newCatContainer" action="" onSubmit={handleSave}
        style={{ height: "75vh", maxHeight: "88vh" }}>
        <div className="newCatContainer_header">
          <h2>Units</h2>
          <XIcon className="closeicon" onClick={close} />
        </div>
        <div className="items_table" style={{ height: "fit-content", padding: "10px 5px 10px", flex: "1" }}>
          <table className="f6 w-100 center" cellSpacing="0">
            <thead className="lh-copy">
              <tr className="white">
                <th className="pa2 bb pl3 tl b--black-20 ">Sr No.</th>
                <th className="pa2 bb pl3 tc b--black-20 ">Unit Title</th>
                <th className="pa2 bb tc b--black-20 ">Conversion</th>
                <th className="pa2 bb tc b--black-20 ">Status</th>
                <th className="pa2 bb tc b--black-20 ">Remarks</th>
              </tr>
            </thead>
            <tbody className="lh-copy">
              {tableData.length > 0 &&
               tableData?.sort((a, b) => a.key - b.key).map((elem, i)=>{
                return <tr key={i.toString()}>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">{i+1}</td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">
                    <div className="inputGroup">
                      {/* {(type!=='edit' || editValues)?   */}
                      <input
                        id="UnitTitle"
                        type="text"
                        maxLength="15"
                        required
                        disabled={i < defaultValueArr.length? true : false}
                        value={tableData.find((a) => +a.key === +i).unit_name}
                        onChange={(e) => {
                          const x = tableData.filter((a) => +a.key !== +i);
                          let y = tableData.find((a) => +a.key === +i);
                          y.unit_name = e.target.value;
                          setTableData([...x,y]);
                        }}
                      />
                      {/* : tableData.find((a)=> a.key==i).unit_name || '-'} */}
                    </div>
                  </td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">
                    {/* {(type!=='edit' || editValues)? */}
                    <input
                      id="Conversion"
                      type="text"
                      className="qtyInput"
                      value={tableData.find((a) => +a.key === +i).conversion}
                      required={tableData.find((a) => +a.key === +i).unit_name}
                      disabled={i < defaultValueArr.length? true : i===0? true: false}
                      onChange={(e) => {
                        var regex = /^([0-9]*)?(\/)?([0-9]*)?$/;
                        if (regex.test(e.target.value)) {
                          const x = tableData.filter((a) => +a.key !== +i);
                          let y = tableData.find((a) => +a.key === +i);
                          y.conversion = e.target.value;
                          setTableData([...x,y]);
                        }
                      }}
                    />
                    {/* : tableData.find((a)=> a.key==i).conversion || '-'} */}
                  </td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">
                    {/* {(type!=='edit' || editValues)? */}
                    <input
                      id="Status"
                      type="checkbox"
                      className="qtyInput"
                      disabled={+tableData[i]?.key === 0 ? true : false}
                      defaultChecked={tableData.find((a) => +a.key === +i).unit_status}
                      value={JSON.parse(
                        tableData.find((a) => +a.key === +i).unit_status
                      )}
                      onChange={(e) => {
                        const x = tableData.filter((a) => +a.key !== +i);
                        let y = tableData.find((a) => +a.key === +i);
                        y.unit_status = !y.unit_status;
                        setTableData([...x, y]);
                      }}
                    />
                    {/* : tableData.find((a)=> a.key==i).unit_status || '-'} */}
                  </td>
                  <td className="ph2 pv1 bb b--black-20 tc bg-white">
                    <div className="inputGroup">
                      {/* {(type!=='edit' || editValues)? */}
                      <input
                        placeholder="Remarks..."
                        type="text"
                        maxLength="200"
                        value={ tableData.find((a) => +a.key === +i).unit_remarks }
                        onChange={(e) => {
                          const x = tableData.filter((a) => +a.key !== +i);
                          let y = tableData.find((a) => +a.key === +i);
                          y.unit_remarks = e.target.value;
                          setTableData([...x, y]);
                        }}
                      />
                      {/* : tableData.find((a)=> a.key==i).unit_remarks || '-'} */}
                    </div>
                  </td>
                </tr>
              })}
              <tr>
                <td onClick={addNewRow}>
                  <AddIcon sx={{ fontSize: 40 }} style={{color: '#4AC959', cursor: 'pointer'}}/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bottomContent">
          {type === "edit" && !editValues ? (
            <button
              onClick={(e) => {
                e.preventDefault();
                setEditValues(true);
                return false;
              }}
            >
              Edit
            </button>
          ) : (
            <button type="submit">Save</button>
          )}
        </div>
      </form>
    </div>
  );
}